/**
 * Bouncing-dot typing indicator shown during API loading states.
 * Matches the Interviewer UX pattern with Hobbes avatar + animated dots.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { HobbesAvatar } from '@/components/interview/HobbesAvatar';
import { messageVariantsLeft, easeOut } from './animations';

interface Props {
  onComplete?: () => void;
}

const ThinkingIndicator: React.FC<Props> = ({ onComplete: _onComplete }) => {
  return (
    <motion.div
      variants={messageVariantsLeft}
      initial="initial"
      animate="animate"
      transition={easeOut}
      className="flex justify-start"
    >
      <div className="flex gap-3">
        <HobbesAvatar size="sm" />
        <div className="rounded-2xl rounded-tl-md bg-muted/50 border border-border/40 px-4 py-2.5 shadow-sm">
          <div className="flex items-center gap-1.5 py-1 px-0.5">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="w-1.5 h-1.5 rounded-full bg-muted-foreground/40"
                style={{
                  animation: 'typing-fade 1.8s ease-in-out infinite',
                  animationDelay: `${i * 0.2}s`,
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes typing-fade {
          0%, 60%, 100% { opacity: 0.25; }
          30% { opacity: 0.8; }
        }
      `}</style>
    </motion.div>
  );
};

export default ThinkingIndicator;
